export class AbsenceDeservedRequest {
    employeeId: number;
    absenceType: number;
}
